import { Typography, TypographyProps } from "@mui/material";
import { ReactNode } from "react";

type CustomTitleProps = {
  children: ReactNode;
  size?: string | number;
  bold?: boolean;
} & TypographyProps;

const CustomTitle = ({ children, bold, ...others }: CustomTitleProps) => {
  return (
    <Typography fontWeight={bold ? "bold" : "medium"} {...others}>
      {children}
    </Typography>
  );
};

export default CustomTitle;
